'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface ContactOption {
  icon: string;
  title: string;
  description: string;
  action: string;
  link: string;
  color: string;
}

export default function QuickContactCard() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const contactOptions: ContactOption[] = [
    {
      icon: 'ChatBubbleLeftRightIcon',
      title: 'WhatsApp Support',
      description: 'Hubungi kami segera',
      action: 'Chat Sekarang',
      link: 'https://wa.me/601173285813',
      color: 'from-[#25D366] to-[#128C7E]',
    },
    {
      icon: 'PhoneIcon',
      title: 'Telefon',
      description: 'Hubungi hotline kami',
      action: '011-73285813',
      link: '',
      color: 'from-primary to-secondary',
    },
    {
      icon: 'EnvelopeIcon',
      title: 'Email',
      description: 'Hantar pertanyaan anda',
      action: 'hello@surilipat.com',
      link: '',
      color: 'from-trustBlue to-primary',
    },
  ];

  if (!isHydrated) {
    return (
      <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-xl p-6 border-2 border-primary/20">
        <div className="text-center mb-6">
          <h3 className="text-2xl font-heading font-bold text-textPrimary mb-2">
            Masih Ada Soalan?
          </h3>
          <p className="text-textSecondary font-body">
            Kami sedia membantu anda dengan sepenuh hati
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {contactOptions.map((option) => (
            <div
              key={option.title}
              className="bg-card rounded-lg p-4 border-2 border-border text-center transition-all duration-300"
            >
              <div
                className={`w-12 h-12 mx-auto mb-3 rounded-full bg-gradient-to-br ${option.color} flex items-center justify-center`}
              >
                <Icon name={option.icon as any} size={24} className="text-white" />
              </div>
              <h4 className="font-heading font-semibold text-textPrimary mb-1">{option.title}</h4>
              <p className="text-sm text-textSecondary mb-3 font-body">{option.description}</p>
              <button
                disabled
                className={`w-full px-4 py-2 bg-gradient-to-r ${option.color} text-white rounded-lg font-cta font-semibold transition-all duration-300`}
              >
                {option.action}
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  }

  const handleContactClick = (link: string) => {
    if (!link) return;
    if (typeof window !== 'undefined') {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-xl p-6 border-2 border-primary/20">
      <div className="text-center mb-6">
        <h3 className="text-2xl font-heading font-bold text-textPrimary mb-2">Masih Ada Soalan?</h3>
        <p className="text-textSecondary font-body">Kami sedia membantu anda dengan sepenuh hati</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {contactOptions.map((option) => (
          <div
            key={option.title}
            className="bg-card rounded-lg p-4 border-2 border-border hover:border-primary text-center transition-all duration-300 hover:shadow-lg transform hover:scale-105"
          >
            <div
              className={`w-12 h-12 mx-auto mb-3 rounded-full bg-gradient-to-br ${option.color} flex items-center justify-center`}
            >
              <Icon name={option.icon as any} size={24} className="text-white" />
            </div>
            <h4 className="font-heading font-semibold text-textPrimary mb-1">{option.title}</h4>
            <p className="text-sm text-textSecondary mb-3 font-body">{option.description}</p>
            <button
              onClick={() => handleContactClick(option.link)}
              className={`w-full px-4 py-2 bg-gradient-to-r ${option.color} text-white rounded-lg font-cta font-semibold hover:shadow-brand transition-all duration-300`}
            >
              {option.action}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
